import { Component, Input, OnInit } from '@angular/core';
import { DocumentServiceGateway } from 'src/app/application/gateway/DocumentServiceGateway';
import { OperationDocumentType } from 'src/app/domain/models/Operation';
import { OperationDocument } from 'src/app/domain/models/OperationDocument';

@Component({
  selector: 'app-list-documents-by-type',
  templateUrl: './list-documents-by-type.component.html',
  styleUrls: ['./list-documents-by-type.component.css']
})
export class ListDocumentsByTypeComponent implements OnInit {

  @Input()
  documentType: OperationDocumentType | undefined

  @Input()
  documents: OperationDocument[] = []

  @Input()
  lang: string = 'en'

  constructor(
    private _documentService: DocumentServiceGateway
  ){

  }

  ngOnInit(): void {
  }

  getDocumentType(): string
  {
    if(this.documentType){
      return this.lang  === 'es ' ? this.documentType.nameEs : this.documentType.name
    }

    return ''
  }

  getOperationDocument(documentId: string) {
    this._documentService.getOperationDocument(documentId).subscribe((resultBlob: any) => {
      var downloadURL = window.URL.createObjectURL(resultBlob.body);
      window.open(downloadURL);})
  }

}
